export default "__VITE_ASSET__DzFEdVpN__"